import React, { useMemo } from "react";

interface SnowflakeProps {
  style: React.CSSProperties;
  size: "sm" | "md" | "lg";
}

const Snowflake: React.FC<SnowflakeProps> = ({ style, size }) => {
  const sizeClasses = {
    sm: "w-2 h-2",
    md: "w-3 h-3",
    lg: "w-4 h-4",
  };

  return (
    <div
      className={`absolute ${sizeClasses[size]} text-white/60 pointer-events-none animate-snowfall`}
      style={style}
    >
      ❄
    </div>
  );
};

interface WinterSnowfallProps {
  count?: number;
}

export const WinterSnowfall: React.FC<WinterSnowfallProps> = ({ count = 30 }) => {
  const snowflakes = useMemo(() => {
    return Array.from({ length: count }, (_, i) => {
      const sizes: Array<"sm" | "md" | "lg"> = ["sm", "md", "lg"];
      const size = sizes[Math.floor(Math.random() * sizes.length)];
      const left = Math.random() * 100;
      const animationDuration = 8 + Math.random() * 12;
      const animationDelay = Math.random() * 10;
      const opacity = 0.3 + Math.random() * 0.5;

      return {
        id: i,
        size,
        style: {
          left: `${left}%`,
          animationDuration: `${animationDuration}s`,
          animationDelay: `${animationDelay}s`,
          opacity,
        } as React.CSSProperties,
      };
    });
  }, [count]);

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-10">
      {snowflakes.map((flake) => (
        <Snowflake key={flake.id} size={flake.size} style={flake.style} />
      ))}
    </div>
  );
};

export default WinterSnowfall;
